module.exports = __webpack_public_path__ + "cc03d16fba5505982a4528d4c6d6e4c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/settings_team.png
// module id = 84
// module chunks = 0 1 2 3 4